import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import PeriodSelector from "../../PeriodSelector/PeriodSelector";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    divider: css`
        margin: 10px 0;
    `,
    textField: css`
        flex-shrink: 0;
        z-index: 0;
        width: 100%;
    `,
    periodSelector: css`
        margin: 40px 10px;
    `,
    periodSelectorGroup: css`
        margin-top: 10px;
        z-index: -1;
    `,
    periodSelectorLabel: css`
        font-size: 75%;
    `,
};

const InputRunSettings = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={classes.instruction}>4. {t("Input run settings")}</div>

            <TextField
                label={t("Run name")}
                placeholder={t("Enter run name...")}
                InputLabelProps={{
                    shrink: true,
                    required: true,
                }}
                value={props.runName || ""}
                className={classes.textField}
                onChange={(e) => {
                    props.onRunNameChanged(e.target.value);
                }}
            />

            <div className={classes.periodSelectorGroup}>
                <div className="hidden">
                    <InputLabel className={classes.periodSelectorLabel}>{t("Estimate years")}</InputLabel>

                    <div className={classes.periodSelector}>
                        <PeriodSelector
                            period={props.period}
                            onChange={props.onChangePeriod}
                        />
                    </div>
                </div>
            </div>

            <Divider className={classes.divider} />
        </div>
    );
};

export default InputRunSettings;
